import { render, staticRenderFns } from "./GeolocationTest.vue?vue&type=template&id=202c3be6&"
import script from "./GeolocationTest.vue?vue&type=script&lang=js&"
export * from "./GeolocationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports